// Resolves a domain's localized display name from the catalog structure's
// `names` map (DomainStructureResponse.names, carried through by
// roleTransformer). A domain declared in the product's config always has
// `en`, so that's the fallback before finally showing the raw id — the only
// option left for a domain the config doesn't declare at all (empty map).
import type { DomainDef } from '../types'

export function domainDisplayName(domain: DomainDef, language: string): string {
  return domain.names[language] ?? domain.names.en ?? domain.domain
}
